<template>
  <div id="ListInsts">
    <b-container>
      <!-- show input field -->
      <div class="input-area">
        <h5><b-icon-search></b-icon-search>地域・最寄り駅から探す</h5>
        <div class="input-field">
          <div class="input-firstline">
            <b-row>

              <b-col cols="auto">
                <b-row>
                  <b-col cols="auto">
                  <b-form-select
                    id="prefecture-select"
                    v-model="selectedPrefecture"
                    :options="prefectures"
                    @change="setCityList"
                  ></b-form-select>

                  </b-col>
                </b-row>
              </b-col>
              <b-col cols="auto">
                <b-row>
                  <b-col cols="auto">
                    <b-form-select
                      v-model="selectedCity"
                      :options="cities"
                    ></b-form-select>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </div>
          <div class="input-secondline">
            <b-row>
              <b-col>
                <b-form-input
                  v-model="inputedStation"
                  placeholder="最寄り駅"
                ></b-form-input>
              </b-col>
              <b-col cols="auto">
                <b-button @click="callapi" variant="primary">検索</b-button>
              </b-col>
            </b-row>
          </div>
          <div v-if="notFoundedFlag" class="not-founded-message">
            <h6>検索条件に合致する機関はありませんでした</h6>
          </div>
        </div>
      </div>

      <!-- show Google Map  -->
      <div class="listmap">
        <MyMap v-bind:selectedPlaces="this.items" v-bind:focusPinId="focusPinId"/>
      </div>


      <!--show table -->
      <div class="list-table">
        <h5>検索結果</h5>
        <b-table
          id="my-table"
          hover
          head-row-variant="primary"
          :items="items"
          :fields="fields"
          stacked="md"
          :per-page="perPage"
          :current-page="currentPage"
          @row-clicked="rowClicked"
        >
          <template #cell(Name)="data">
            <img v-if="data.item.Category === '病院'" src="/triangle_purple.png" width="25" height="25">
            <img v-else-if="data.item.Category === '診療所'" src="/triangle_blue.png" width="25" height="25">
            <img v-else-if="data.item.Category === '緩和ケア病棟がある病院'" src="/triangle_red.png" width="25" height="25">
            <img v-else-if="data.item.Category === '訪問診療可能な医療機関'" src="/triangle_yellow.png" width="25" height="25">
            <img v-else-if="data.item.Category === '健診センター'" src="/triangle_green.png" width="25" height="25">
            {{ data.item.Name }}
            <b-button v-if="data.item.EnableUrlLink && data.item.Url !== 'NULL'" @click="openUrl(data.item.Url)" size="sm" class="mb-2" variant="light">
              <b-icon-back font-scale="1" variant="primary"></b-icon-back>
            </b-button>
          </template>

          <template #cell(Address)="data">
            <!-- <b-button 
              v-if="data.item.Latitude !== 0 && data.item.Longitude !== 0"
              @click="pushPinId(data.item.PublicId)" variant="primary" size="sm"
            >地図</b-button> -->
            {{ data.item.Address }} 
          </template>
          <template #cell(UpdatedYear)="data">
            <p v-if="data.item.PublicId != -1">
              {{ data.item.UpdatedYear}}/{{data.item.UpdatedMonth}} 
            </p>
          </template>
        </b-table>
        <b-pagination
          v-model="currentPage"
          :total-rows="rows"
          :per-page="perPage"
          aria-controls="my-table"
          align="center"
        ></b-pagination>
      </div>
    </b-container>
  </div>
</template>

<script>
import MyMap from "./MyMap.vue";

export default {
  name: "ListInsts",
  components: {
    MyMap,
  },
  data() {
    return {
      notFoundedFlag: false,
      perPage: 10,
      currentPage: 1,
      text: null,
      selectedPrefecture: null,
      selectedCity: null,
      inputedStation: null,
      jsondata: null,
      focusPinId: null,
      cityList:{
        "東京":[
          "渋谷",
          "中央",
          "世田谷", 
          "江東",
        ],
        "千葉":[
          "千葉市",
          "野田市",
          "松戸市",
        ],
        "神奈川":[
          "川崎市",
        ],
        "埼玉":[
          "越谷市",
          "さいたま市",
        ],
      },
      ncc: {
          PublicId: -1,
          Name: "国立がん研究センター中央病院",
          Address: "東京都中央区築地５丁目１-１",
          PhoneNumber: "03-3542-251",
          NearestStation: "築地市場駅",
          Department: "呼吸器科",
          Category: "国立がんセンター",
          Latitude: 35.665406457112724,
          Longitude: 139.7683468338116,
          EnableUrlLink:true,
          Url: "https://www.ncc.go.jp/jp/ncch/"
      },
      fields: [
        {
          label: "病院名",
          key: "Name",
        },
        {
          label: "住所",
          key: "Address",
        },
        {
          label: "電話番号",
          key: "PhoneNumber",
        },
        {
          label: "更新年月",
          key: "UpdatedYear",
        },
      ],
      items: [
        {
          PublicId: -1,
          Name: "国立がん研究センター中央病院",
          Address: "東京都中央区築地５丁目１-１",
          PhoneNumber: "03-3542-251",
          NearestStation: "築地市場駅",
          Department: "呼吸器科",
          Category: "国立がんセンター",
          Latitude: 35.665406457112724,
          Longitude: 139.7683468338116,
          Url: "https://www.ncc.go.jp/jp/ncch/"
       },
      ],
      prefectures: [
        { value: null, text: "都道府県選択" },
        "東京",
        "千葉",
        "埼玉",
        "神奈川",
      ],
      cities: [
        { value: null, text: "地域選択" },
      ],
    };
  },
  methods: {
    rowClicked: function(record){
      if (record.Latitude == 0 || record.Longitude == 0)
        return;
      console.log(record.PublicId);
      window.scrollTo({
          top: 0,
          behavior: "smooth"
      }); 
      this.focusPinId = record.PublicId;
    },
    testapicall: async function(){
      var res;
      var apiurl = process.env.VUE_APP_TEST_APIURL;
      console.log(apiurl);

      await this.axios
        .get(apiurl,{headers:{Authorization:"THISISTEST"},withCredentials:true,})
        .then((response) => (res = response.data))
        .catch(error => {
          console.log("CATCHED ERROR");
          console.log(error)
        });
      console.log(res);
    },
    setCityList: function(){
      this.selectedCity = null;
      if (this.selectedPrefecture == null)
        this.cities = [];
      else
        this.cities = this.cityList[this.selectedPrefecture].slice(0, this.cityList[this.selectedPrefecture].length);
      this.cities.unshift({value: null, text: "地域選択"});
    },
    openUrl: function(url){
      window.open(url, '_blank')
    },
    pushPinId: function(id) {
     window.scrollTo({
        top: 0,
        behavior: "smooth"
      }); 
      this.focusPinId = id
    },
    generateApiUrl: function () {
      var apiurl = "/api/ListInstitutions/GetSearchedMedInstApi?";

      if (this.selectedPrefecture !== null) {
        apiurl += "&prefecture=" + this.selectedPrefecture;
        if (this.selectedCity !== null)
          apiurl += "&district=" + this.selectedCity;
      }
      if (this.inputedStation !== null && this.inputedStation !=="")
        apiurl += "&station=" + this.inputedStation;
      return apiurl;
    },

    callapi: async function () {
      var res;
      var apiErrored = false;

      var apiurl = this.generateApiUrl();
      this.notFoundedFlag = false;
      await this.axios
        .get(apiurl)
        .then((response) => (res = response.data))
        .catch(error => {
          console.log(error)
          apiErrored = true;
        });

      // DEBUG
      console.log("DEBUG2:API returns this data");
      console.log(res);

      if (!apiErrored)
      {
        if (res.length === 0) 
        {
          this.notFoundedFlag = true;
          res.push(this.ncc);
          this.items = res;
        }
        else
          this.items = res;
      }
    },

    setPrefectureCityList: async function() {
      var apiRequestErroed = false;
      var res;
      var apiurl = "/api/ListInstitutions/GetPullDownListApi";
      await this.axios
        .get(apiurl)
        .then((response) => (res = response.data))
        .catch(error => {
          console.log(error);
          apiRequestErroed = true;
        });
      if (!apiRequestErroed) {
        this.prefectures = Object.keys(res);
        this.prefectures.unshift({value: null, text: "都道府県選択"});
        this.cityList = res;
      }
    }
  },
  computed: {
    isPrefectureSelected: function () {
      if (this.selectedPrefecture === null) return true;
      else return false;
    },
    rows(){
      return this.items.length
    }
  },
  async mounted(){
    await this.setPrefectureCityList();
  }
};
</script>

<style scoped>
h5 {
  color: #005fad;
  font-weight: bold;
}
.listMap {
  margin-top: 30px;
}
.input-area {
  margin-top: 15px;
}
.input-field {
  border-radius: 8px;
  background-color: rgb(160, 204, 241);
  padding-top: 30px;
  padding-bottom: 30px;
  padding-left: 30px;
  padding-right: 30px;
  margin-bottom: 20px;
}

.input-firstline {
  padding-bottom: 20px;
  font-size: 1.3rem;
}

.form-title {
  color: #005fad;
}

.list-table {
  margin-top: 20px;
}

.rowcustom > td {
  border-bottom: 3px solid green !important;
}

.not-founded-message {
  margin-top:10px;
  color: #dc3545;
}
</style>
